import { useEffect } from "react";
import { useParams, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DEFAULT_LANG, SUPPORTED_LANGS } from "../i18n";

export default function I18nWrapper({ children }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (lang && SUPPORTED_LANGS.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  if (!lang || !SUPPORTED_LANGS.includes(lang)) {
    return (
      <Navigate
      to={`/${i18n.language}${location.pathname}${location.search}`}        replace
      />
    );
  }

  return children;
}
